/*
  PrüfDoc Pro – Betreiber-Seite "Individuell-Angebot" (nur für Plattform-Admins).
  Hier legen Sie für einen Träger den Tarif Individuell mit eigenem Monatspreis
  und eigener Einrichtungsgebühr an. Route /admin/individuell.
*/
import { useEffect, useState } from 'react';
import api from '@/lib/api';

async function orgsLaden() {
  const r = await api.get('/admin/organizations');
  return r.data || [];
}
const feld = { display: 'flex', flexDirection: 'column', gap: 6, fontWeight: 600, fontSize: 14 };
const eingabe = { font: 'inherit', fontSize: 16, fontWeight: 400, padding: '10px 12px', border: '1.5px solid #C3CDD6', borderRadius: 8, background: '#fff' };
const eur = (n) => Number(n || 0).toLocaleString('de-DE', { style: 'currency', currency: 'EUR' });

export default function AdminIndividuell() {
  const [orgs, setOrgs] = useState([]);
  const [f, setF] = useState({ org_id: '', firma: '', email: '', monatspreis_eur: 249, einrichtung_eur: 490, zahlweise: 'rechnung', zahlungsziel_tage: 14 });
  const [ergebnis, setErgebnis] = useState(null);
  const [fehler, setFehler] = useState('');
  const [laedt, setLaedt] = useState(false);
  useEffect(() => { orgsLaden().then(setOrgs).catch(() => {}); }, []);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.type === 'number' ? Number(e.target.value) : e.target.value });
  function orgWaehlen(e) {
    const o = orgs.find((x) => x.id === e.target.value);
    setF({ ...f, org_id: e.target.value, firma: o?.name || f.firma, email: o?.billing_email || o?.email || f.email });
  }
  async function absenden(e) {
    e.preventDefault();
    setFehler(''); setErgebnis(null); setLaedt(true);
    try {
      const { data } = await api.post('/billing/admin/individuell-angebot', f);
      setErgebnis(data);
    } catch (err) { setFehler(err.response?.data?.detail || err.message || 'Fehler'); }
    setLaedt(false);
  }
  return (
    <form onSubmit={absenden} style={{ maxWidth: 640, margin: '0 auto', padding: '32px 20px', display: 'flex', flexDirection: 'column', gap: 16 }} data-testid="admin-individuell-page">
      <h1 style={{ margin: 0 }} className="text-4xl sm:text-5xl font-head font-extrabold tracking-tight">Individuell-Angebot anlegen</h1>
      <p style={{ margin: 0, color: '#55606B' }}>Monatspreis und Einrichtung frei wählen. Abgerechnet wird jährlich (Monatspreis × 12), die Einrichtung einmalig auf der ersten Rechnung.</p>
      <label style={feld}>Organisation
        <select required value={f.org_id} onChange={orgWaehlen} style={eingabe} data-testid="individuell-org-select">
          <option value="">– bitte wählen –</option>
          {orgs.map((o) => <option key={o.id} value={o.id}>{o.name}</option>)}
        </select>
      </label>
      <label style={feld}>Träger / Firma (für die Rechnung)<input required value={f.firma} onChange={set('firma')} style={eingabe} data-testid="individuell-firma-input" /></label>
      <label style={feld}>Rechnungs-E-Mail<input required type="email" value={f.email} onChange={set('email')} style={eingabe} data-testid="individuell-email-input" /></label>
      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
        <label style={feld}>Monatspreis (€, Endpreis)<input required type="number" min="1" step="1" value={f.monatspreis_eur} onChange={set('monatspreis_eur')} style={eingabe} data-testid="individuell-preis-input" /></label>
        <label style={feld}>Einrichtung einmalig (€, Endpreis)<input required type="number" min="0" step="1" value={f.einrichtung_eur} onChange={set('einrichtung_eur')} style={eingabe} data-testid="individuell-einrichtung-input" /></label>
      </div>
      {f.monatspreis_eur < 249 && <div style={{ color: '#9A5B00' }}>Hinweis: unter dem Listenpreis von 249 € im Monat.</div>}
      <fieldset style={{ border: '1px solid #D5DCE2', borderRadius: 8, padding: 14 }}>
        <legend style={{ fontWeight: 600 }}>Zahlweise</legend>
        <label style={{ display: 'block', marginBottom: 8 }}>
          <input type="radio" name="zw" checked={f.zahlweise === 'rechnung'} onChange={() => setF({ ...f, zahlweise: 'rechnung' })} data-testid="individuell-zw-rechnung" /> Auf Rechnung (Überweisung oder online bezahlen), Zahlungsziel{' '}
          <input type="number" min="1" max="60" value={f.zahlungsziel_tage} onChange={set('zahlungsziel_tage')} style={{ ...eingabe, width: 70, padding: '4px 8px' }} data-testid="individuell-ziel-input" /> Tage
        </label>
        <label style={{ display: 'block' }}>
          <input type="radio" name="zw" checked={f.zahlweise === 'link'} onChange={() => setF({ ...f, zahlweise: 'link' })} data-testid="individuell-zw-link" /> Bezahl-Link für den Kunden (Karte/Lastschrift, danach automatische Abbuchung)
        </label>
      </fieldset>
      <div style={{ background: '#F5F7F8', borderRadius: 8, padding: 14 }}>
        <strong>Erste Rechnung:</strong> {eur(f.monatspreis_eur * 12)} Jahresbeitrag{f.einrichtung_eur > 0 ? ` + ${eur(f.einrichtung_eur)} Einrichtung = ${eur(f.monatspreis_eur * 12 + f.einrichtung_eur)}` : ''} (Kleinunternehmer, ohne USt.)<br />
        <strong>Danach jährlich:</strong> {eur(f.monatspreis_eur * 12)}
      </div>
      {fehler && <div role="alert" style={{ color: '#9B1C1C' }} data-testid="individuell-error">{fehler}</div>}
      {ergebnis && (
        <div style={{ background: '#E8F7EF', color: '#13784A', borderRadius: 8, padding: 14 }} data-testid="individuell-result">
          {ergebnis.info}{ergebnis.hinweis ? ` (${ergebnis.hinweis})` : ''}
          {ergebnis.url && (
            <div style={{ marginTop: 8 }}>
              <input readOnly value={ergebnis.url} style={{ ...eingabe, width: '100%' }} onFocus={(e) => e.target.select()} data-testid="individuell-link-output" />
              <button type="button" onClick={() => navigator.clipboard.writeText(ergebnis.url)} style={{ marginTop: 8 }} data-testid="individuell-copy-btn">Link kopieren</button>
            </div>
          )}
        </div>
      )}
      <button type="submit" disabled={laedt} style={{ minHeight: 48, fontWeight: 700, borderRadius: 8, border: 'none', background: '#E8650A', color: '#fff' }} data-testid="individuell-submit-btn">{laedt ? 'Wird angelegt …' : 'Angebot anlegen'}</button>
    </form>
  );
}
